import { render, staticRenderFns } from "./add-back-info.vue?vue&type=template&id=155150f3&scoped=true"
import script from "./add-back-info.vue?vue&type=script&lang=js"
export * from "./add-back-info.vue?vue&type=script&lang=js"
import style0 from "./add-back-info.vue?vue&type=style&index=0&id=155150f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155150f3",
  null
  
)

export default component.exports